import { ActionButton } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { debounce, noop } from 'lodash';
import { useCallback, useContext, useEffect, useState } from 'react';
import Sketch from 'react-color/lib/Sketch';
import { CtxEdit } from 'session/ctxEdit';
import styled from 'styled-components/macro';

interface Props {
    value?: string;
    className?: string;
    onChange?: (color: string) => void;
}

export const ColorPickerButton = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [currentValue, setCurrentValue] = useState(props.value);

    const onChangeDebounced = useCallback(props.onChange ? debounce(props.onChange, 200) : noop, [
        props.onChange
    ]);

    useEffect(() => {
        if (props.value !== currentValue) {
            console.log('callback', props.value, currentValue);
            ctxEdit.setMarkerDefault({ ...ctxEdit.markerDefault, color: currentValue });
            onChangeDebounced?.(currentValue);
        }
    }, [currentValue]);

    useEffect(() => {
        if (props.value !== currentValue) {
            setCurrentValue(currentValue);
        }
    }, [props.value]);

    return (
        <S_ColorPickerButton className={props.className}>
            <ActionButton
                icon={{ iconName: 'palette' }}
                onClick={() => {
                    setDisplayColorPicker((curr) => !curr);
                }}
            />
            {displayColorPicker ? (
                <S_Popover>
                    <S_Cover
                        onClick={() => {
                            setDisplayColorPicker(false);
                        }}
                    />
                    <Sketch
                        color={currentValue ?? '#000'}
                        presetColors={[]}
                        disableAlpha={true}
                        onChange={(color) => {
                            setCurrentValue(color.hex);
                        }}
                    />
                </S_Popover>
            ) : null}
        </S_ColorPickerButton>
    );
};

const S_ColorPickerButton = styled.div`
    position: relative;
`;

const S_Popover = styled.div`
    position: absolute;
    z-index: 2;
    top: 41px;
    right: 0px;
`;

const S_Cover = styled.div`
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
`;
